import React from "react";
import { FaMusic } from "react-icons/fa";

const linkText = (track, seo) =>
  seo ? `${track.kstSongTitle} — Kingdom Soundtracks` : track.kstSongTitle;

const KstTrackLinks = ({ kstTracks, seo = false }) => {
  if (!kstTracks || kstTracks.length === 0) {
    return null;
  }

  const kstBaseUrl = window.env?.KST_BASE_URL || "";

  if (!kstBaseUrl) {
    console.warn("window.env.KST_BASE_URL is not set. KST links will not render correctly.");
  }

  return (
    <div className="kst-track-links" style={{ marginTop: "4px", marginBottom: "8px" }}>
      <FaMusic aria-hidden="true" style={{ fontSize: "0.75rem", color: "#6B7280", verticalAlign: "middle", marginRight: "4px" }} />
      <span style={{ fontSize: "0.78rem", color: "#6B7280" }}>
        Buy on Kingdom Soundtracks:{" "}
      </span>
      <span style={{ fontSize: "0.78rem", color: "#6B7280" }}>
        {kstTracks.map((track, index) => (
          <React.Fragment key={track.slug || `${track.kstSongTitle}-${index}`}>
            {index > 0 && <span aria-hidden="true"> · </span>}
            {kstBaseUrl ? (
              <a
                href={`${kstBaseUrl}/tracks/${track.slug}?utm_source=theworshipbible&utm_medium=referral&utm_campaign=song_link`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Buy ${track.kstSongTitle} on Kingdom Soundtracks (opens in new tab)`}
                style={{ color: "#6B7280", textDecoration: "none" }}
                onMouseEnter={e => (e.currentTarget.style.textDecoration = "underline")}
                onMouseLeave={e => (e.currentTarget.style.textDecoration = "none")}
              >
                {linkText(track, seo)}
              </a>
            ) : (
              <span>{linkText(track, seo)}</span>
            )}
          </React.Fragment>
        ))}
      </span>
    </div>
  );
};

export default KstTrackLinks;
